import { articlesApi } from "./articles";
import { bimApi } from "./bim";
import { bimPointApi } from "./bimPoint";
import { calculationsApi } from "./calculation";
import { companiesApi } from "./companies";
import { contactApi } from "./contact";
import { explorerFsApi } from "./explorerfs";
import { bimIssuesApi } from "./issues";
import { jobTypesApi } from "./job-types";
import { logAuthsApi } from "./logAuths";
import { mailApi } from "./mail";
import { mailTemplatesApi } from "./mailTemplates";
import { materialRequirementsApi } from "./material-requirements";
import { normSetsApi } from "./norm-sets";
import { offersApi } from "./offers";
import { parameterApi } from "./parameter";
import { paymentTermsApi } from "./payment-terms";
import { projectTypesApi } from "./project-types";
import { projectsApi } from "./projects";
import { proxyApi } from "./proxy";
import { purchasingInvoicesApi } from "./purchasing-invoices";
import { salesInvoicesApi } from "./sales-invoices";
import { sequenceNumbersApi } from "./sequenceNumbers";
import { stageApi } from "./stage";
import { templatesApi } from "./templates";
import { usersApi } from "./users";
import { warehouseApi } from "./warehouse";
import { workLogApi } from "./workLog";

export const apiMethods = {
  ...contactApi,
  ...purchasingInvoicesApi,
  ...companiesApi,
  ...normSetsApi,
  ...articlesApi,
  ...bimIssuesApi,
  ...usersApi,
  ...offersApi,
  ...sequenceNumbersApi,
  ...calculationsApi,
  ...explorerFsApi,
  ...bimApi,
  ...bimPointApi,
  ...salesInvoicesApi,
  ...mailApi,
  ...parameterApi,
  ...mailTemplatesApi,
  ...templatesApi,
  ...logAuthsApi,
  ...proxyApi,
  ...stageApi,
  ...materialRequirementsApi,
  ...warehouseApi,
  ...workLogApi,
  ...projectsApi,
  ...paymentTermsApi,
  ...projectTypesApi,
  ...jobTypesApi,
};
